module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Light.cf0f18dd.eot";